<div class="root-body"
     [ngClass]="{
    'root-body-sidebar-slim': configService.config.menuMode === 'sidebar' || configService.config.menuMode === 'slim',
    'root-body-sidebar-static': configService.config.menuMode === 'sidebar' && configService.config.sidebarStatic,
    'root-body-horizontal': configService.config.menuMode === 'horizontal'}">
    <p-toast></p-toast>

    <driver-detail [_visibleDetail]="visibleDetail"
                   [_driverId]="selectedDriver.RiderId"
                   [showEditFields]="false"
                   [showCampaignButton]="true"
                   (changedVisibleDetailEmit)="changedVisibleDetailEmit($event)"
                   *ngIf="visibleDetail"></driver-detail>

    <drivers-compaign-export-sidebar *ngIf="showDriversCompaignExportSidebar"
                                     [showDriversCompaignExportSidebar]="showDriversCompaignExportSidebar"
                                     [menuHome]="menuHomeEnumActive"
                                     [exportHeaderColumns]="exportHeaderColumns"
                                     [exportDataColumns]="exportDataColumns"
                                     [selectedDateRange]="selectedDateRange"
                                     [driverVehicleTypes]="driverVehicleTypes"
                                     [driverServiceTypes]="driverServiceTypes"
                                     [driverCampaign]="driverCampaignTypeEnum.CampaignDriver"
                                     (changedShowDriversCompaignExportSidebarEmit)="changedShowDriversCompaignExportSidebarEmit($event)"></drivers-compaign-export-sidebar>

    <p-breadcrumb class="breadcrumb mb-3" [model]="breadcrumbs"></p-breadcrumb>

    <div class="card">
        <div class="onboarding-head">
            <div class="onboarding-head-fleft">
                <div class="onboarding-head-title">
                    Campaign Drivers
                </div>
            </div>
            <div class="flex flex-row onboarding-head-right">
                <span class="onboarding-head-date p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" class="search-input"
                           [(ngModel)]="filter.searchName" (input)="handleFilterChange()"
                           placeholder="Search here..." />
                </span>
                <div class="ml-3">
                    <p-calendar [appendTo]="'body'"
                                [inputStyle]="{'height': '45px', 'background-color': 'white', 'color': 'black'}"
                                (onSelect)="changeDateRange()" [(ngModel)]="selectedDateRange" selectionMode="range"
                                [readonlyInput]="true" [showIcon]="true"></p-calendar>
                </div>
                <div class="ml-3">
                    <button pButton pRipple
                            class="p-element btn-darkblue p-button p-component"
                            (click)="handleShowDriversCompaignExportSidebar()">
                        Export
                    </button>
                </div>
                <div class="ml-3 mt-1">
                    <column-selector #columnSelector
                         [defaultColumns]="defaultCols"
                         (selectedColumnsChange)="onSelectedColumnsChange($event)"
                         [tableName]="tableName"
                         [(selectedColumns)]="cols">
                    </column-selector>
                </div>
            </div>
        </div>

        <!-- Table -->
        <p-table #xpressUsersGrid
                 [columns]="cols"
                 [value]="riders"
                 [lazy]="true"
                 responsiveLayout="scroll"
                 dataKey="Id"
                 selectionMode="single"
                 (onLazyLoad)="handleLazyLoad($event)"
                 [loading]="loading"
                 [showFirstLastIcon]="false"
                 [paginator]="true"
                 [(first)]="first"
                 [rows]="rowsPerPage"
                 [selection]="selectedDriver"
                 [totalRecords]="totalRecords"
                 [resizableColumns]="true"
                 [columnResizeMode]="'expand'"
                 [autoLayout]="true"
                 [styleClass]="'p-datatable-gridlines'"
                 [scrollable]="true"
                 [scrollHeight]="'flex'"
                 [style]="{height: 'calc(100vh - 270px)'}">
            <ng-template pTemplate="caption">
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th *ngFor="let col of cols"
                        [pSortableColumn]="col.field"
                        [pSortableColumnDisabled]="col.disableSort"
                        pResizableColumn
                        [style.width]="col.width">
                        {{col.header}}
                        <p-sortIcon class="column-sorticon" [field]="col.field"></p-sortIcon>
                    </th>
                    <th>Action</th>
                </tr>
                <tr>
                    <ng-container *ngFor="let item of cols">
                        <th class="overflow-unset">
                            <ng-container *ngIf="item.fieldType === fieldTypeEnum.Inputs">
                                <input type="text" pInputText placeholder="{{item.placeholder}}" [(ngModel)]="driverHeaderSearch[item.model]"
                                       (input)="handleFilterChange()" />
                            </ng-container>
                            <ng-container *ngIf="item.fieldType === fieldTypeEnum.InputNumber">
                                <p-inputNumber inputId="integeronly" placeholder="{{item.placeholder}}" [(ngModel)]="driverHeaderSearch[item.model]"
                                               (ngModelChange)="handleFilterChange()"> </p-inputNumber>
                            </ng-container>
                            <ng-container *ngIf="item.fieldType === fieldTypeEnum.Dropdown">
                                <ng-container *ngIf="item.take === 'obj'; else dropdown">
                                    <p-dropdown [options]="item.options" placeholder="{{item.placeholder}}"
                                                optionLabel="name" [(ngModel)]="driverHeaderSearch[item.model]"
                                                (ngModelChange)="handleFilterChange()"></p-dropdown>
                                </ng-container>
                                <ng-template #dropdown>
                                    <p-dropdown [options]="item.options" placeholder="{{item.placeholder}}"
                                                optionLabel="name" optionValue="value" [(ngModel)]="driverHeaderSearch[item.model]"
                                                (ngModelChange)="handleFilterChange()"></p-dropdown>
                                </ng-template>
                            </ng-container>
                            <ng-container *ngIf="item.fieldType === fieldTypeEnum.Calendar">
                                <p-calendar [(ngModel)]="driverHeaderSearch[item.model]"
                                            [showIcon]="true"
                                            placeholder="{{item.placeholder}}"
                                            dateFormat="dd M yy"
                                            (ngModelChange)="handleFilterChange()" />
                            </ng-container>
                        </th>
                    </ng-container>                    <th></th>
            </ng-template>
            <ng-template pTemplate="body" let-rider>
                <tr [pSelectableRow]="rider">
                    <td class="ui-resizable-column text-center" *ngFor="let item of cols" (click)="handleShowDriverInfo(rider)">
                        <span class="col-compaign" *ngIf="item.field === 'Status'"
                              [style.background-color]="rider.StatusBgColor"
                              [style.color]="rider.StatusColor">{{rider.Status}}
                        </span>
                        <span *ngIf="item.field !== 'Status'">{{rider[item.field]}}</span>
                    </td>
                    <td>
                        <span class="driver-add-campaign-btn" (click)="addOrRemoveRiderCampaign(rider)" *ngIf="rider.IsBelongCompany">
                            <img src="/XpressApp/assets/images/delete-cross.png" alt="Remove from campaign" />
                        </span>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="paginatorleft" let-state>
                <div *ngIf="riders.length > 0" style="padding-left: 10px">
                    Showing {{first + 1}} to {{first + riders.length}} of {{totalRecords}} entries
                </div>
            </ng-template>
        </p-table>
    </div>
</div>
